// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DigitalInstrumentalCluster_colLg17__33Rc1 {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% / 7);
  max-width: calc(100% / 7);
}

.DigitalInstrumentalCluster_pl0Important__dPG19 {
  padding-left: 0 !important;
}

.DigitalInstrumentalCluster_kipBoxes__QykZN
{
  border: 1.5px solid #32879c;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
  margin-left: 1px;
}

.DigitalInstrumentalCluster_kpiHeight__z8\\+SJ{
  height: 65px;
  min-height: 65px;
  justify-content: center;
}

.DigitalInstrumentalCluster_fw_600__aGX3u {
  font-weight: 600 !important;
}

.DigitalInstrumentalCluster_KPI_left_right_card__Um8T1{
  background: #32879c;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.DigitalInstrumentalCluster_KPI_right_left_Card__aPHdC{
  background: #32879c;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.DigitalInstrumentalCluster_forBetweenBorder__U7EjP{
  border-right: black 1px solid;
  margin: 4px 0px 4px 0px;
}

.DigitalInstrumentalCluster_textColorGreen__UEEva{
  color: #32879c;
}

.DigitalInstrumentalCluster_tableTitles__5z0lf{
  border-radius: 5px;
  padding: 6px 0px;
  display: flex;
  justify-content: center;
  font-size: 0.90rem !important;
  font-weight: 600 !important;
}

.DigitalInstrumentalCluster_fullTable__wcI1x{
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
}

.DigitalInstrumentalCluster_topBottomPerformingTables__Df7dL {
  height: 400px; /* Set the height of the table container */
  overflow-y: scroll; /* Add vertical scroll when content overflows */
  margin-bottom: 0;
  scrollbar-width: thin; 
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/RangePolygon/DigitalInstrumentalCluster.module.css"],"names":[],"mappings":"AAAA;EACE,YAAwB;EAAxB,cAAwB;EAAxB,0BAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;EACE,aAAa,EAAE,0CAA0C;EACzD,kBAAkB,EAAE,+CAA+C;EACnE,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".colLg17 {\n  flex: 0 0 calc(100% / 7);\n  max-width: calc(100% / 7);\n}\n\n.pl0Important {\n  padding-left: 0 !important;\n}\n\n.kipBoxes\n{\n  border: 1.5px solid #32879c;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n  margin-left: 1px;\n}\n\n.kpiHeight{\n  height: 65px;\n  min-height: 65px;\n  justify-content: center;\n}\n\n.fw_600 {\n  font-weight: 600 !important;\n}\n\n.KPI_left_right_card{\n  background: #32879c;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.KPI_right_left_Card{\n  background: #32879c;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.forBetweenBorder{\n  border-right: black 1px solid;\n  margin: 4px 0px 4px 0px;\n}\n\n.textColorGreen{\n  color: #32879c;\n}\n\n.tableTitles{\n  border-radius: 5px;\n  padding: 6px 0px;\n  display: flex;\n  justify-content: center;\n  font-size: 0.90rem !important;\n  font-weight: 600 !important;\n}\n\n.fullTable{\n    border-radius: 6px;\n    background: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n}\n\n.topBottomPerformingTables {\n  height: 400px; /* Set the height of the table container */\n  overflow-y: scroll; /* Add vertical scroll when content overflows */\n  margin-bottom: 0;\n  scrollbar-width: thin; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colLg17": `DigitalInstrumentalCluster_colLg17__33Rc1`,
	"pl0Important": `DigitalInstrumentalCluster_pl0Important__dPG19`,
	"kipBoxes": `DigitalInstrumentalCluster_kipBoxes__QykZN`,
	"kpiHeight": `DigitalInstrumentalCluster_kpiHeight__z8+SJ`,
	"fw_600": `DigitalInstrumentalCluster_fw_600__aGX3u`,
	"KPI_left_right_card": `DigitalInstrumentalCluster_KPI_left_right_card__Um8T1`,
	"KPI_right_left_Card": `DigitalInstrumentalCluster_KPI_right_left_Card__aPHdC`,
	"forBetweenBorder": `DigitalInstrumentalCluster_forBetweenBorder__U7EjP`,
	"textColorGreen": `DigitalInstrumentalCluster_textColorGreen__UEEva`,
	"tableTitles": `DigitalInstrumentalCluster_tableTitles__5z0lf`,
	"fullTable": `DigitalInstrumentalCluster_fullTable__wcI1x`,
	"topBottomPerformingTables": `DigitalInstrumentalCluster_topBottomPerformingTables__Df7dL`
};
export default ___CSS_LOADER_EXPORT___;
